import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="question-type"
export default class extends Controller {
  static targets = [ 
    "input", 
    "answers",
    "multiple",
    "true_false"
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.inputTarget.value
    this.answersTarget.classList.toggle("hidden", type === "open_ended")
  }
}
